/** German catalog, keyed by the English source text. Filled in a later delivery. */
export const germanSite: Record<string, string> = {};
